import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  marginBottom: {
    marginBottom: theme.spacing(2),
  },
  richTextMarginBottom: {
    marginBottom: theme.spacing(8),
  },
  actionButtons: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  saveButton: {
    marginLeft: 'auto',
  },
  addStepButton: {
    borderColor: 'transparent',
  },
  addStepButtonError: {
    borderColor: 'transparent',
    color: theme.palette.error.main,
    '&:hover': {
      backgroundColor: theme.palette.error.light,
    },
  },
}));
